module.exports = __webpack_public_path__ + "img/ic_banner_refeere.11da7f8.svg";